import React, { useEffect, useState } from "react";
import { db } from "../firebase"; // تأكد من إعداد Firebase بشكل صحيح
import { collection, query, where, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";

const AgenciesPage = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPartners = async () => {
      const partnersRef = collection(db, "users"); // جلب مجموعة المستخدمين
      const q = query(partnersRef, where("role", "==", "partner")); // تصفية حسب الدور: 'partner'

      try {
        const querySnapshot = await getDocs(q);
        const partnersList = querySnapshot.docs.map(doc => ({
          id: doc.id, // تضمين معرّف المستند للتوجيه
          ...doc.data(),
        }));
        setPartners(partnersList);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching partners: ", error);
        setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  if (loading) {
    return <div className="text-center p-4">جار التحميل...</div>;
  }

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold text-center mb-6">وكالات الشركاء</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {partners.length > 0 ? (
          partners.map((partner) => (
            <div
              className="bg-white p-4 rounded-lg shadow-md hover:shadow-xl transition-shadow"
              key={partner.id}
            >
              <img
                src={partner.photoURL || "https://via.placeholder.com/150"}
                alt="Profile"
                className="w-24 h-24 rounded-full object-cover mb-4 mx-auto"
              />
              <h2 className="text-xl font-semibold text-gray-800 text-center">
                {partner.name || "الاسم غير متوفر"}
              </h2>
              <p className="text-gray-600 text-center">{partner.email}</p>
              <p className="text-gray-600 text-center">{partner.phone}</p>
              <div className="mt-4 text-center">
                <Link
                  to={`/user/${partner.id}/offers`}
                  className="bg-green-500 text-white py-2 px-4 rounded-lg hover:bg-green-600"
                >
                  عرض العروض
                </Link>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-gray-500">لم يتم العثور على شركاء.</p>
        )}
      </div>
    </div>
  );
};

export default AgenciesPage;
